import { useCallback, useContext } from 'react';
import UserContext from '../context/UserContext/UserContext';
import UserService from '../services/UserService/UserService';
import UserRole from '../types/UserRole';
import ContextUser from '../types/ContextUser';
import useEffectiveOrganisationId from './useEffectiveOrganisationId';

const useUserActions = () => {
  const { user, setUser } = useContext(UserContext);
  const effectiveOrganisationId = useEffectiveOrganisationId();

  const deleteUser = useCallback(
    (userId: number): Promise<string> => {
      return UserService.deleteUser(
        userId,
        effectiveOrganisationId ?? undefined
      );
    },
    [effectiveOrganisationId]
  );

  const updateUserRole = useCallback(
    (userId: number, role: UserRole): Promise<string | ContextUser> => {
      return UserService.updateUserRole(userId, role).then((updatedUser) => {
        if (userId === user?.id) {
          setUser(updatedUser);
        }
        return updatedUser;
      });
    },
    [user?.id, setUser]
  );

  const resendInvite = useCallback(
    async (userEmail: string): Promise<string> => {
      return UserService.resendInviteEmail(
        userEmail,
        effectiveOrganisationId ?? undefined
      );
    },
    [effectiveOrganisationId]
  );

  return { deleteUser, updateUserRole, resendInvite };
};

export default useUserActions;
